import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const McdLedgerList = () => {
  const { navState } = useNavState();
  const { searchBoxQuery } = useEntityMgr();

  const augRowsReq = useCallback(
    (rowsReq) => {
      if (navState?.expr !== undefined) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, navState.expr);
      }
      if (searchBoxQuery) {
        let fields = ['state', 'prog', 'labeler', 'rbtPeriod'];
        let searchParts = searchBoxQuery.split(' ').filter((part) => part);
        let searchFieldExprs = searchParts.map((searchPart) => {
          let exprs = fields.map((field) => ExprUtils.contains(field + 'Code', searchPart));
          return ExprUtils.or(...exprs);
        });

        let searchExpr = ExprUtils.and(...searchFieldExprs);
        rowsReq.expr = ExprUtils.and(rowsReq.expr, searchExpr);
      }
    },
    [navState?.expr, searchBoxQuery],
  );

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.stateId.precedence = 0;
    fieldToFieldDef.stateId.hasName = false;

    fieldToFieldDef.progId.precedence = 1;
    fieldToFieldDef.progId.hasName = false;

    fieldToFieldDef.labelerId.precedence = 2;
    fieldToFieldDef.labelerId.hasName = false;

    fieldToFieldDef.earnedPeriodId.precedence = 3;
    fieldToFieldDef.earnedPeriodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // // 3. Units
    // fieldToFieldDef.invUnits.precedence = 2000;
    // fieldToFieldDef.dispUnits.precedence = 2001;
    // fieldToFieldDef.dueUnits.precedence = 2002;
    // fieldToFieldDef.paidUnits.precedence = 2003;

    // // 4. URAs
    // fieldToFieldDef.invUra.precedence = 3000;
    // fieldToFieldDef.calcUra.precedence = 3001;

    // 5. Amounts
    fieldToFieldDef.rbtAmt.precedence = 4001;
    fieldToFieldDef.dispAmt.precedence = 4002;
    fieldToFieldDef.dueAmt.precedence = 4003;
    fieldToFieldDef.paidAmt.precedence = 4004;

    // 6. Other
    // fieldToFieldDef.mcdInvOrigin.precedence = 9000;
    // fieldToFieldDef.postmarkDate.precedence = 9001;
    // fieldToFieldDef.dueDate.precedence = 9002;
    // fieldToFieldDef.pymtDate.precedence = 9003;
    // fieldToFieldDef.lineCount.precedence = 9004;
    // fieldToFieldDef.valLineCount.precedence = 9005;
    // fieldToFieldDef.mcdStateId.precedence = 9006;
    // fieldToFieldDef.mcdInvDateTrackerId.precedence = 9007;
    // fieldToFieldDef.payWithoutCld.precedence = 9008;
  };

  return <EntityList entity="MCD_LEDGER" augRowsReq={augRowsReq} augFieldDefs={augFieldDefs} />;
};
